// Pay-per-use credit packs. 1 credit = 1 warp (one full application
// generation). Prices in USD; Stripe localizes per country. See
// docs/superpowers/specs/2026-05-30-monetization-credits-design.md.

export type CreditPack = {
  id: string;
  warps: number;
  priceUsd: number;
  label: string;
  popular: boolean;
};

export const CREDIT_PACKS: readonly CreditPack[] = [
  { id: "starter", warps: 10, priceUsd: 9, label: "Starter", popular: false },
  { id: "sprint", warps: 30, priceUsd: 19, label: "Sprint", popular: true },
  { id: "pro", warps: 75, priceUsd: 39, label: "Pro", popular: false },
  { id: "max", warps: 150, priceUsd: 69, label: "Max", popular: false },
];

// Warps granted once per verified account (wired up in the anti-abuse plan).
export const WELCOME_GRANT_WARPS = 3;

// Returned by the API (HTTP 402) when a warp/regenerate is attempted with an
// empty balance. The frontend opens the paywall in response.
export const INSUFFICIENT_CREDITS_CODE = "insufficient_credits";

export function findCreditPack(id: string): CreditPack | undefined {
  return CREDIT_PACKS.find((p) => p.id === id);
}
